<template>
  <div ref="container" class="grid crud-demo">
    <div class="col-12">
      <div class="card">
        <Toast/>
        <h5 class="m-0 p-3">{{ $t('students_by_degree') }}</h5>
        <Toolbar class="p-1">
          <template v-slot:start>
            <div >
              <Button :label="$t('New')" icon="pi pi-plus" class="p-button-text p-button-plain mr-2 hide-text-on-mobile larger-icon" @click="openNew"/>
              <Button :label="$t('Edit')" icon="pi pi-pencil" class="p-button-text p-button-plain hide-text-on-mobile larger-icon" @click="editProduct"
                      v-show="selectedProducts && selectedProducts.length === 1"/>
              <Button :label="$t('Delete')" icon="pi pi-trash" class="p-button-text p-button-plain hide-text-on-mobile larger-icon" @click="confirmDeleteSelected"
                      v-show="!(!selectedProducts || !selectedProducts.length)"/>
            </div>
          </template>

          <template v-slot:end>
            <div class="hide-on-mobile">
            <FileUploadOwn mode="basic"
                           accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                           :maxFileSize="1000000" :label="$t('Import')" :chooseLabel="$t('Import')"
                           class="mr-2 p-button-text p-button-plain hide-on-mobile hide-text-on-mobile larger-icon" /></div>
            <Button :label="$t('Export')" icon="pi pi-upload" class="p-button-text p-button-plain hide-on-mobile hide-text-on-mobile larger-icon" @click="exportCSV($event)"/>
            <hr class="custom-separator hide-on-mobile" />
            <Button :label="$t('Print')" icon="pi pi-print" class="p-button-text p-button-plain hide-on-mobile hide-text-on-mobile larger-icon" @click="printCSV"/>
            <hr class="custom-separator hide-on-mobile" />
            <Button :label="$t('Filter')" icon="pi pi-filter" class="p-button-text p-button-plain hide-text-on-mobile larger-icon" @click="openFilterDialog"/>
            <Button :label="$t('Reset Filters')" icon="pi pi-filter-slash" class="p-button-text p-button-plain hide-text-on-mobile larger-icon" @click="resetFilters"/>

          </template>
        </Toolbar>
        <hr class="mb-1 mt-0">
        <div class="mb-2 p-3 flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global'].value" :placeholder="$t('Search') + '...'"/>
                            </span>
        </div>
        <DataTable ref="dt" :value="getStudentByDegree.data"
                   :globalFilterFields="['year_name', 'degree_level_translated', 'finance_type_translated']"
                   stateStorage="session" stateKey="dt-state-demo-session" selectionMode="multiple"
                   v-model:selection="selectedProducts" dataKey="id" :rows="rowsCount" :filters="filters"
                   class="paginator"  responsiveLayout="scroll"
                   paginator>

          <Column selectionMode="multiple" style="" headerStyle="width: 3rem"></Column>
          <Column field="year_name" filterField="year_name" :header="$t('year')" :sortable="true" :filter="filters.year">
            <template #body="slotProps">
              <span class="p-column-title">{{ $t('year') }}</span>
              {{ slotProps.data.year_name }}
            </template>
          </Column>
          <Column field="degree_level_name" filterField="degree_level_translated" :header="$t('degree_level')" :sortable="true" :filter="filters.degree_level">
             <template #body="slotProps">
              <span class="p-column-title"> {{$t('degree_level') }}</span>
              {{ $t(slotProps.data.degree_level_name) }}
            </template>
          </Column>
          <Column field="finance_type_name" filterField="finance_type_translated" :header="$t('finance_type')" :sortable="true" :filter="filters.finance_type">
          <template #body="slotProps">
              <span class="p-column-title">{{  $t('finance_type')  }}</span>
              {{ $t(slotProps.data.finance_type_name) }}
            </template>
          </Column>
          <Column field="count" :sortable="true" :header="$t('count')" :filter="filters.count">
            <template #body="slotProps">
              <span class="p-column-title">{{  $t('count')  }}</span>
              {{ slotProps.data.count }}
            </template>
          </Column>

        </DataTable>

        <Dialog v-model:visible="productDialog" :style="{width: '450px'}" :header="product.id ? $t('Edit1') : $t('Create')"
                :modal="true" class="p-fluid">
          <div class="mt-4 field">
            <div class="p-float-label">
              <Dropdown id="year" v-model="product.year" :options="getCatYear" optionLabel="name"></Dropdown>
              <label for="yearpicker">{{ $t('current_year') }}</label>
            </div>
            <small class="p-invalid" v-if="submitted && !product.year">Year is required.</small>
          </div>
          <div class="field">
            <div class="p-float-label">
              <Dropdown id="degree_level" v-model="product.degree_level" :options="getCatDegreeLevels" optionLabel="name" >
                <template v-if="product.degree_level" #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ $t(slotProps.value.name) }}</div>
                  </div>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ $t(slotProps.option.name) }}</div>
                  </div>
                </template>
              </Dropdown>              <label for="degree_level">{{ $t('degree_level') }}</label>
            </div>

            <small class="p-invalid" v-if="submitted && !product.degree_level">Degree level is required.</small>
          </div>

          <div class="field">
            <div class="p-float-label">
              <Dropdown id="finance_type" v-model="product.finance_type" :options="getCatFinanceTypes" optionLabel="name" >
                <template v-if="product.finance_type" #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ $t(slotProps.value.name) }}</div>
                  </div>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ $t(slotProps.option.name) }}</div>
                  </div>
                </template>
              </Dropdown>
              <label for="finance_type">{{ $t('finance_type') }}</label>
            </div>

            <small class="p-invalid" v-if="submitted && !product.finance_type">Finance type is required.</small>
          </div>

          <div class="field">
            <span class="p-float-label">
              <InputNumber id="count" v-model="product.count" integeronly/>
              <label for="count">{{ $t('count') }}</label>
            </span>
            <small class="p-invalid" v-if="submitted && product.count === null">Count is required.</small>
          </div>

          <template #footer>
            <Button :label="$t('cancel')" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button :label="$t('Save')" icon="pi pi-check" class="p-button-text" @click="saveProduct"/>
          </template>
        </Dialog>

        <Dialog v-model:visible="deleteProductDialog" :style="{width: '450px'}" :header="$t('confirmation')" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"/>
            <span v-if="product">{{ $t('A_u_want_delete') }} <b>{{ product.name }}</b>?</span>
          </div>
          <template #footer>
            <Button :label="$t('No')" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false"/>
            <Button :label="$t('Yes')" icon="pi pi-check" class="p-button-text" @click="deleteProduct"/>
          </template>
        </Dialog>

        <Dialog v-model:visible="deleteProductsDialog" :style="{width: '450px'}" :header="$t('confirmation')" :modal="true">
          <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem"/>
            <span v-if="product">Are you sure you want to delete the selected products?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductsDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts"/>
          </template>
        </Dialog>
        <Dialog v-model:visible="filterDialog" :style="{width: '450px'}" :header="$t('Filter')" :modal="true" class="p-fluid">
          <div class="mt-1 field">
            <div class="p-float-label">
              <Dropdown id="yearFilter" v-model="filterOptions.year" :options="getCatYear" optionLabel="name" >
              </Dropdown>
              <label for="yearFilter">{{ $t('year') }}</label>
            </div>

          </div>
          <div class="field">
            <div class="p-float-label">
              <Dropdown id="degreeLevelFilter" v-model="filterOptions.degree_level" :options="getCatDegreeLevels" optionLabel="name" >
                <template v-if="filterOptions.degree_level" #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ $t(slotProps.value.name) }}</div>
                  </div>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ $t(slotProps.option.name) }}</div>
                  </div>
                </template>
              </Dropdown>
              <label for="degreeLevelFilter">{{ $t('degree_level') }}</label>
            </div>

          </div>
          <div class="field">
            <div class="p-float-label">
              <Dropdown id="financeTypeFilter" v-model="filterOptions.finance_type" :options="getCatFinanceTypes" optionLabel="name" >
                <template v-if="filterOptions.finance_type" #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ $t(slotProps.value.name) }}</div>
                  </div>
                </template>
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ $t(slotProps.option.name) }}</div>
                  </div>
                </template>
              </Dropdown>
              <label for="financeTypeFilter">{{ $t('finance_type') }}</label>
            </div>

          </div>
          <template #footer>
            <Button :label="$t('cancel')" icon="pi pi-times" class="p-button-text" @click="filterDialog = false" />
            <Button :label="$t('Apply')" icon="pi pi-check" class="p-button-text" @click="applyFilters" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>

</template>

<script>
import {FilterMatchMode} from 'primevue/api';
import FileUploadOwn from '../primevue/fileupload/FileUpload.vue';
import store from "@/store";
import axiosClient from "@/axios";
import printTableMixin from '../mixins/printTableMixin';

export default {
  mixins: [printTableMixin],
  components:{
    FileUploadOwn
  },
  data() {
    return {
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      product: {},
      selectedProducts: null,
      filters: {},
      submitted: false,
      filterDialog: false,
      rowsCount: 13,
      filterOptions: {},
    }
  },
  created() {
    this.initFilters();
  },
  beforeUpdate() {
    this.calculateRowsCount();
  },
  mounted() {
    store.dispatch("getStudentByDegree");
  },
  computed: {
    getStudentByDegree() {
      const studentByDegree = store.state.student_by_degree;

      studentByDegree.data.forEach((student) => {
        student.degree_level_translated = this.$t(student.degree_level_name);
        student.finance_type_translated = this.$t(student.finance_type_name);
      });

      return studentByDegree;
    },
    getCatYear() {
      return store.state.public_data.data.cat_year
    },
    getCatDegreeLevels() {
      return store.state.public_data.data.cat_degree_level
    },
    getCatFinanceTypes() {
      return store.state.public_data.data.cat_finance_type
    },
  },
  methods: {
    calculateRowsCount() {
      const rowHeight = 75;
      const newRowCount = Math.floor((window.innerHeight - 100) / rowHeight);

      if (this.rowsCount !== newRowCount) {
        this.rowsCount = newRowCount;
        this.$forceUpdate();
      }
    },
    resetFilters() {
      this.filterOptions = {};
      this.initFilters();
    },
    openFilterDialog() {
      this.filterDialog = true;
    },
    applyFilters() {
      this.filters = {
        ...this.filters,
        year_name: {value: this.filterOptions.year ? this.filterOptions.year.name : null, matchMode: FilterMatchMode.CONTAINS},
        degree_level_translated: {value: this.filterOptions.degree_level ? this.$t(this.filterOptions.degree_level.name) : null, matchMode: FilterMatchMode.CONTAINS},
        finance_type_translated: {value: this.filterOptions.finance_type ? this.$t(this.filterOptions.finance_type.name) : null, matchMode: FilterMatchMode.CONTAINS},
      };
      this.filterDialog = false;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    sendPost() {

      const updatedProduct = {
        degree_level_id: this.product.degree_level.id,
        finance_type_id: this.product.finance_type.id,
        year_id: this.product.year.id,
        count: this.product.count,
      };
      if (this.product.id) {
        axiosClient.put('/student_by_degree/' + this.product.id, {...updatedProduct})
          .then(({data}) => {
            store.dispatch("getStudentByDegree");
            return data;
          })
      }else{
        axiosClient.post('/student_by_degree', {...updatedProduct})
          .then(({data}) => {
            store.dispatch("getStudentByDegree");
            return data;
          })
      }
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.id) {
        this.sendPost()
        this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Product Updated', life: 3000});
      } else { // push to server
        this.sendPost()
        this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Product Created', life: 3000});
      }
      this.productDialog = false;
      this.product = {};
    },
    editProduct() {
      this.product = {...this.selectedProducts[0]};
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      // send post
      axiosClient.delete('/student_by_degree/' + this.product.id)
        .then(({data}) => {
          store.dispatch("getStudentByDegree");
          return data;
        })
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Product Deleted', life: 3000});
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      if (this.selectedProducts && this.selectedProducts.length > 0) {
        this.deleteProductsDialog = true;
      }
    },
    deleteSelectedProducts() {
      const ids = this.selectedProducts.map(p => p.id);
      axiosClient.delete('/student_by_degree', { data: { ids: ids } })
        .then(() => {
          this.deleteProductsDialog = false;
          this.selectedProducts = null;
          // Refresh the product list after deletion
          store.dispatch("getStudentByDegree");
        })
        .catch(() => {
          this.$toast.add({severity:'error', summary:'Error', detail:'Failed to delete the selected products.'});
        });
    },
    printCSV() {
      const data = this.getStudentByDegree.data;
      const headers = [
        { field: 'year_name', title: this.$t('year') },
        { field: 'degree_level_name', title: this.$t('degree_level') },
        { field: 'finance_type_name', title: this.$t('finance_type') },
        { field: 'count', title: this.$t('count') },
      ];

      this.printTable(data, headers, 'Print Student By Degree');
    },
    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/demo/styles/badges.scss';
</style>

<style scoped >


.larger-icon::v-deep .p-button-icon {
  font-size: 1.3rem;
}
.hide-text-on-mobile {
  min-width: 0
}
.hide-text-on-mobile::v-deep .p-button-label {
  font-size: 0;
  padding: 0;
  width: auto;
}
.hide-text-on-mobile::v-deep .p-button-icon-left {
  margin-right: 0;
}
.hide-text-on-mobile::v-deep .p-button-icon {
  margin-left: 0;
  margin-right: 0;
}
.custom-separator {
    height: 24px;
    width: 1px;
    background-color: #ccc;
    margin: 0 10px;
    border: none;
    display: inline-block;
  }
 .hide-on-mobile {
   display: none;
 }
@media (min-width: 768px) {
  .hide-text-on-mobile::v-deep .p-button-label {
    font-size: 14px;
    padding: 0;
    width: auto;
  }
  .hide-text-on-mobile::v-deep .p-button-icon-left {
    margin-right: 1rem;
  }
  .hide-text-on-mobile::v-deep .p-button-icon {
    margin-left: 0;
    margin-right: 7px;
  }
  .hide-text-on-mobile {
    min-width: 51px
  }
  .larger-icon::v-deep .p-button-icon {
    font-size: 1rem;
  }
}
::v-deep (.p-checkbox .p-checkbox-box) {
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

:v-deep (.p-datatable .p-paginator) {
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.paginator .p-paginator {
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}
@media (min-width: 768px) {
  .hide-on-mobile {
    display: initial;
  }
}
</style>
